import React, { createRef, useEffect, useState, Fragment } from 'react';
import { Tooltip, Col } from 'antd';
import useWindowSize from '../../utils/useWindowSize';

export default function TooltipTrimmed({ str, maxLength, notXs, ...tooltipProps }) {
  const [width] = useWindowSize();

  if (width < 576 && notXs) {
    return str;
  } else if (maxLength < str.length) {
    return (
      <Tooltip
        title={str}
        {...tooltipProps}
      >
        {`${str.substring(0, maxLength)}...`}
      </Tooltip>
    );
  } else return str;
}

function resize(cRef, tRef, str, set) {
  return () => {
    if (!cRef || !tRef) {
      return false;
    }

    if (cRef.offsetWidth < tRef.offsetWidth) {
      set(str.length * cRef.offsetWidth / tRef.offsetWidth);
    } else {
      set(false);
    }
  }
}

export function TooltipTrimmedNew({ str, ...tooltipProps }) {
  const ref = createRef();
  const textRef = createRef();
  const [trimmed, setTrimmed] = useState();

  useEffect(() => {
    window.addEventListener('resize', resize(ref.current, textRef.current, str, setTrimmed));
    resize(ref.current, textRef.current, str, setTrimmed)();
    return () => {
      window.removeEventListener('resize', resize(ref.current, textRef.current, str, setTrimmed))
    }
  }, [ref.current, textRef.current, str])

  return (
      <div ref={ref} style={{ display: 'flex', flex: 1 }}>
        <span ref={textRef} style={{ position: 'absolute', opacity: 0, whiteSpace: 'nowrap', top: 0, left: 0 }}>
        {str}.....
      </span>
        {trimmed ? (
          <Tooltip
            title={str}
            {...tooltipProps}
          >
            {str.substring(0, trimmed)}...
          </Tooltip>
        ) : str}
      </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Tooltip/TooltipTrimmed.js